<template>
  <div>
    <Head title="Campaigns" />
    <h1 class="mb-8 text-xl font-bold">Campaigns</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/admin/campaigns/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Campaign</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Organization</th>
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Step</th>
            <th class="pb-4 pt-6 px-6">Type</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="campaign in campaigns.data" :key="campaign.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="px-6 border-t">
              {{ campaign.organization_name }}
              <icon v-if="campaign.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </td>
            <td class="px-6 border-t">
              {{ campaign.name }}
            </td>
            <td class="border-t">
              {{ campaign.campaign_step }}
            </td>
            <td class="border-t">
              {{ campaign.campaign_type }}
            </td>
            <td class="border-t">
              {{ campaign.description }}
            </td>
            <td class="w-px border-t">
              <Link class="inline-block items-center px-4" :href="`/campaigns/${campaign.id}`" tabindex="-1"> <icon name="cheveron-down" class="block w-6 h-6 fill-gray-400" /> Show </Link>

              <Link class="inline-block items-center px-4" :href="`/campaigns/${campaign.campaign_plan_id}/planning`" tabindex="-1"> <i class="fa fa-search" aria-hidden="true" /> &nbsp; Planning </Link>
              <Link class="inline-block items-center px-4" :href="`/campaigns/${campaign.campaign_implementation_id}/implementation`" tabindex="-1"> <i class="fa fa-map" aria-hidden="true" /> &nbsp; Implementation </Link>
              <!--
              <Link class="inline-block items-center px-4" :href="getImplementationStageIdsLink(campaign.id)" tabindex="-1"> <i class="fa fa-search" aria-hidden="true" /> &nbsp; Implementation </Link>
              <Link class="inline-block items-center px-4" :href="getPlanStageIdsLink(campaign.id)" tabindex="-1"> <i class="fa fa-search" aria-hidden="true" /> &nbsp; Planning </Link>

              <Link class="inline-block items-center px-4" tabindex="-1" :href="getImplementationStageIds(campaign.id)"> <i class="fa fa-search" aria-hidden="true" /> &nbsp; Implementation </Link>
              <Link class="inline-block items-center px-4" tabindex="-1" :href="getPlanStageIds(campaign.id)"> <i class="fa fa-search" aria-hidden="true" /> &nbsp; Planning </Link>
              -->
              <Link class="inline-block items-center px-4" :href="`/campaigns/${campaign.id}/edit`" tabindex="-1"> <i class="fa fa-cogs" aria-hidden="true" /> &nbsp; Edit </Link>
            </td>
          </tr>
          <tr v-if="campaigns.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No campaigns found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="campaigns.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    campaigns: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/campaigns', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
